import {Component, Input, OnChanges, ChangeDetectionStrategy} from '@angular/core';
import {CraningBillingDto, CraningBillingItemDto, CraningBillingService} from '../../../../../../_services/configuration-services';
import {TranslateUtils} from '../../../../../../_shared/translate-utils';
import {Observable} from 'rxjs';

@Component({
    selector: 'app-craning-booking-form-bill-details-component',
    templateUrl: './craning-booking-form-bill-details-component.component.html',
    styleUrls: ['./craning-booking-form-bill-details-component.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CraningBookingFormBillDetailsComponentComponent implements OnChanges {

    @Input() slotId: number;
    @Input() serviceId: string;
    @Input() isExploitantView = false;
    @Input() crtLang = TranslateUtils.defaultLanguage;

    craningBillingDto: CraningBillingDto;

    constructor(private readonly craningBillingService: CraningBillingService) {}

    ngOnChanges(): void {
        this.fetchCraningBillingDto();
    }

    private fetchCraningBillingDto(): void {
        // An exploitant reads the bill of any slot of their service; a customer only reads their own.
        const billing$: Observable<CraningBillingDto> = this.isExploitantView
            ? this.craningBillingService.getBillForSlotIdForExploitant(this.serviceId, this.slotId)
            : this.craningBillingService.getBillForSlotId(this.slotId);

        billing$
            .pipe()
            .subscribe(craningBillingDto => {
                this.craningBillingDto = craningBillingDto;
            });
    }


    getCraningServiceLabel(craningBillingItemDto: CraningBillingItemDto): string {
        return craningBillingItemDto['craningItemLabel' + this.crtLang.toUpperCase()];
    }
}
